import * as Yup from 'yup'

import { phoneNumberSchema } from 'i18n-web/validators'
import { i18n } from 'i18n-web/i18next'

const validationSchema = countryCode =>
  Yup.object().shape({
    phoneNumber: phoneNumberSchema({ countryCode }),
    password: Yup.string().max(20, i18n.t('signIn.form.password.error')),
  })

export default validationSchema
